import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SlideComponent = ({ actual, first, second }) => {
    const { t } = useTranslation();
    const [selectedButtonGroup1, setSelectedButtonGroup1] = useState(null);
    const [selectedButtonGroup2, setSelectedButtonGroup2] = useState(null);

    useEffect(() => {
        const savedAnswer = JSON.parse(localStorage.getItem('currentAnswer') || '[]');
        if (savedAnswer.selectedButtonGroup0) setSelectedButtonGroup1(savedAnswer.selectedButtonGroup0);
        if (savedAnswer.selectedButtonGroup1) setSelectedButtonGroup2(savedAnswer.selectedButtonGroup1);
    }, []);

    return (
        <div className="an-slide">
            <h2 className="an-slide-title">{t('visual.title')}</h2>

            <div className="an-section">
                <div className="an-section-title">{t('visual.intensity')}</div>
                <div className="an-buttons">
                    {first.question.map((item, index) => (
                        <span key={index} className={`an-btn${selectedButtonGroup1 === item.option ? ' an-btn-selected' : ''}`}>
                            {item.option}
                        </span>
                    ))}
                </div>
            </div>

            <div className="an-section">
                <div className="an-section-title">{t('visual.color')}</div>
                <div className="an-buttons">
                    {second.question.map((item, index) => (
                        <span key={index} className={`an-btn${selectedButtonGroup2 === item.option ? ' an-btn-selected' : ''}`}>
                            {item.option}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SlideComponent;
